import { get_axios_instance, api_variables, get_axios_file_instance, errorHandler, errorLogSheet } from '@/apis/variables.js';

var axios_instance = get_axios_instance(api_variables.SERVICE_VARIABLES);
var axios_instance_upload_template = get_axios_file_instance(api_variables.SERVICE_PAYMENT_DEDUCTION_UPLOAD_TEMPLATE);
var axios_instance_employee_salary_components = get_axios_file_instance(api_variables.SERVICE_EMPLOYEE_SALARY_COMPONENTS);
var axios_instance_download_template_New = get_axios_file_instance(api_variables.SERVICE_DOWNLOAD_EARNING_DEDUCTION_TEMPLATE);
var axios_instance_upload_template_New = get_axios_file_instance(api_variables.SERVICE_UPLOAD_EARNING_DEDUCTION_TEMPLATE);

const state = {
    data: [],
    variableearnings: {},
    isFetching: false,
    isSaving: false,
    isDeleting: false
};

const mutations = {
    set: (state, payload) => {
        state.data = payload;
    },

    setVariableEarnings: (state, payload) => {
        if (payload) {
            state.variableearnings = payload;
        }
    },

    addEmployee: (state, payload) => {
        state.variableearnings = payload;
        // state.data.push(payload);
    },

    setFetching: (state, payload) => {
        state.isFetching = payload;
    },

    setSaving: (state, payload) => {
        state.isSaving = payload;
    },

    setDeleting: (state, payload) => {
        state.isDeleting = payload;
    }
};

const actions = {
    async fetchAll({ commit }, payload) {
        try {
            commit('setFetching', true);
            let res = await axios_instance.get(`/`);
            commit('setFetching', false);
            if (res.status == 200) {
                commit('set', payload);
            }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async fetchVariableEarnings({ commit }, payload) {
        try {
            commit('setFetching', true);
            let res = await axios_instance.get(`/`, {
                params: {
                    paygroupId: payload
                }
            });
            commit('setFetching', false);
            if (res.status == 200) {
                commit('setVariableEarnings', res.data.rows);
            }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async fetchEmployeeSalaryComponents({ commit }, payload) {
        try {
            commit('setFetching', true);
            let res = await axios_instance_employee_salary_components.get(`/`, {
                params: {
                    emp_id: payload
                }
            });
            commit('setFetching', false);
            if (res.status == 200) {
                //commit('setVariableEarnings', res.data.rows);
            }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async create({ commit }, payload) {
        try {
            commit('setSaving', true);
            let res = await axios_instance.post('/',payload);
            commit('setSaving', false);
            if (res.status == 200) {
                commit('addEmployee', payload);
            }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async update({ commit }, payload) {
        try {
            commit('setSaving', true);
            let res = await axios_instance.put(`/${payload.id}`, payload);
            commit('setSaving', false);
            if (res.status == 200) {
                commit('updateEmployeeById', res.data);
            }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async delete({ commit }, payload) {
        try {
            commit('setDeleting', true);
            let res = await axios_instance.delete(`/${payload.id}`);
            commit('setDeleting', false);
            if (res.status == 200) {
                commit('removeEmployeeById', payload.id);
            }
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async uploadTemplate({ commit }, payload) {
        try {
            commit('setFetching', true);
            let res = await axios_instance.get(`/`);
            commit('setFetching', false);
            if (res.status == 200) {
                commit('set', payload);
            }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async fileuploadTemplate({ commit }, payload) {
        try {
            // commit("setFetching", true);
            let res = await axios_instance_upload_template.post(``, payload);
            // commit("setFetching", false);
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async getEmployeeTemplate({commit},payload) {
        try {
          let res = await axios_instance_download_template_New.get(``, {
            params: payload
          });
          if (res.data.status) {
            const link = document.createElement("a");
            link.href = res.data.payload;
            link.setAttribute("download", "EarningAndDeductionTemplate"+ ".xlsx"); //or any other extension
            document.body.appendChild(link);
            link.click();
        }
        } catch (err) {
            throw errorHandler(error);
        }
      },

    async fileuploadTemplateNew({ commit }, payload) {
        try {
            // commit("setFetching", true);
            let res = await axios_instance_upload_template_New.post(``, payload);
            // commit("setFetching", false);
            return res;
        } catch (error) {
            //console.log(error.response);
            throw errorLogSheet(error.response);
        }
    }
    
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};